// src/services/adminApi.js
import qs from 'qs';
import { FUNCTION_KEY } from '../utils/constants';

const API_BASE = process.env.REACT_APP_ADMIN_API_BASE;

function withAuthAndFuncKey(token) {
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(FUNCTION_KEY ? { 'x-functions-key': FUNCTION_KEY } : {}),
  };
}

async function httpGet(url, { token, query } = {}) {
  const q = query ? `?${qs.stringify(query, { arrayFormat: 'repeat' })}` : '';
  const res = await fetch(`${API_BASE}${url}${q}`, {
    method: 'GET',
    headers: withAuthAndFuncKey(token),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`GET ${url} ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

async function httpPost(url, { token, body } = {}) {
  const res = await fetch(`${API_BASE}${url}`, {
    method: 'POST',
    headers: withAuthAndFuncKey(token),
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`POST ${url} ${res.status}: ${text || res.statusText}`);
  }
  return res.json().catch(() => ({}));
}

async function httpDelete(url, { token, body } = {}) {
  const res = await fetch(`${API_BASE}${url}`, {
    method: 'DELETE',
    headers: withAuthAndFuncKey(token),
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`DELETE ${url} ${res.status}: ${text || res.statusText}`);
  }
  return res.json().catch(() => ({}));
}

export const adminApi = {
  async listUsers({ token, page = 0, per_page = 20, q = '' }) {
    const base = await httpGet('/v1/admin/users', {
      token,
      query: { page, per_page, q },
    });
    const users = Array.isArray(base?.users) ? base.users : [];
    return { users };
  },

  async listRoles({ token }) {
    const data = await httpGet('/v1/admin/roles', { token });
    return { roles: Array.isArray(data?.roles) ? data.roles : [] };
  },

  async getUserRoles({ token, user_id }) {
    const data = await httpGet(`/v1/admin/users/${encodeURIComponent(user_id)}/roles`, { token });
    return { roles: Array.isArray(data?.roles) ? data.roles : [] };
  },

  async assignRoles({ token, user_id, role_ids }) {
    return httpPost(`/v1/admin/users/${encodeURIComponent(user_id)}/roles`, {
      token,
      body: { role_ids },
    });
  },

  async removeRoles({ token, user_id, role_ids }) {
    return httpDelete(`/v1/admin/users/${encodeURIComponent(user_id)}/roles`, {
      token,
      body: { role_ids },
    });
  },
};